export {default} from '../../../core/components/Repository/FilterText';